module.exports = __webpack_public_path__ + "img/AlimentadorCtmtBdgd.c32d04dc.png";